const initCouponTags = (root = document) => {
  const tags = root.querySelectorAll('[data-coupon-tag]');

  tags.forEach((tag) => {
    if (tag.dataset.couponTagInitialized === 'true') return;
    tag.dataset.couponTagInitialized = 'true';

    const intervalSeconds = parseFloat(tag.dataset.swapInterval || '1.5');
    const intervalMs = Math.max(100, intervalSeconds * 1000);
    let showAlternate = false;

    window.setInterval(() => {
      showAlternate = !showAlternate;
      tag.classList.toggle('is-alternate', showAlternate);
    }, intervalMs);

    tag.addEventListener('click', async () => {
      const code = tag.dataset.couponCode;
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => initCouponTags());
document.addEventListener('shopify:section:load', (event) => initCouponTags(event.target));
document.addEventListener('shopify:section:reorder', (event) => initCouponTags(event.target));
document.addEventListener('shopify:section:select', (event) => initCouponTags(event.target));
